import { useGrowthBook } from '@growthbook/growthbook-react';
import usePD7364RedirectToCityList from './usePD7364RedirectToCityList';

function PD7364EnrolledRedirect(): null {
  usePD7364RedirectToCityList();
  return null;
}

// The hook enrolls on render, so it can only mount once logged_in is already set.
export default function PD7364HomepageRedirect({
  isLoggedIn,
}: {
  isLoggedIn: boolean;
}): JSX.Element | null {
  const growthbook = useGrowthBook();
  if (!isLoggedIn || growthbook?.getAttributes()?.logged_in !== true) return null;
  return <PD7364EnrolledRedirect />;
}
